import { CommonModule } from '@angular/common';
import { AfterViewInit, Component, inject, Input, OnInit } from '@angular/core';
import { menuReinitialization } from '../../../../kt/kt-helpers';
import { InitialsPipe } from '../../../../../../pipes/initials.pipe';
import { KeeniconComponent } from '../../../../../keenicon/keenicon.component';
import { InlineSVGModule } from 'ng-inline-svg-2';
import { UserInnerComponent } from '../../../../../header-dropdowns/user-inner/user-inner.component';
import { ActiveCompanyComponent } from '../../../../../header-dropdowns/active-company/active-company.component';
import { HeaderCompaniesComponent } from '../../../../../header-dropdowns/header-companies/header-companies.component';
import { AuthService } from '../../../../../../services/auth.service';
import { BehaviorSubject } from 'rxjs';
import { CompanyModel } from '../../../../../../models/company.model';
import { CompaniesService } from '../../../../../../services/company.service';
@Component({
	selector: 'app-navbar',
	templateUrl: './navbar.component.html',
	styleUrls: ['./navbar.component.scss'],
	imports: [CommonModule, InitialsPipe, KeeniconComponent, InlineSVGModule, UserInnerComponent, ActiveCompanyComponent, HeaderCompaniesComponent],
	standalone: true,
})
export class NavbarComponent implements AfterViewInit, OnInit {
	@Input() appHeaderDefaulMenuDisplay = true;
	@Input() isRtl!: boolean;

	itemClass = 'ms-1 ms-lg-3';
	btnClass = 'btn btn-icon btn-custom btn-icon-muted btn-active-light btn-active-color-primary w-35px h-35px w-md-40px h-md-40px';
	userAvatarClass = 'symbol-35px symbol-md-40px';
	btnIconClass = 'fs-2 fs-md-1';
	user: any;
	private auth = inject(AuthService);
	public companiesService = inject(CompaniesService);

	company$: BehaviorSubject<CompanyModel> = new BehaviorSubject<CompanyModel>(new CompanyModel());
	company: CompanyModel;

	ngAfterViewInit(): void {
		menuReinitialization();
	}
	ngOnInit(): void {
		this.auth.getUserByToken();
		this.auth.currentUser$.subscribe((user: any) => {
			if (user) this.user = user;
		});
		this.companiesService.setActiveCompany(this.company$.value);
	}
}
